import { Box, Modal as MuiModal, Backdrop, Fade } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledModal = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(255, 255, 255, 0.98)",
  borderRadius: theme.spacing(2),
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(90, 100, 119, 0.2)",
  boxShadow: "0 8px 32px rgba(90, 100, 119, 0.2)",
  padding: theme.spacing(3),
  maxHeight: "80vh",
  maxWidth: "90vw",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: "95vw",
    margin: theme.spacing(1),
    padding: theme.spacing(2),
  },
}));

interface Props {
  children: JSX.Element | JSX.Element[];
  open?: boolean;
  onClose?: () => void;
}

export const Modal = ({ children, open = true, onClose }: Props) => {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
          },
        },
      }}
    >
      <Fade in={open} timeout={600}>
        <StyledModal>{children}</StyledModal>
      </Fade>
    </MuiModal>
  );
};
